export default {
    storeManagementFeeBySectionList: [],
    isStoreManagementFeeBySectionDialogOpen: false,
    isStoreManagementFeeBySectionAddFeeSectionOpen: false,
    selectedStoreId: '',
    editFeeItem: {},
};
